module.exports = __webpack_public_path__ + "img/device_am35_a.ad478323.png";